import debug from 'bows';

let log = debug('analytics');

export const trackEvent = function( category, action, label ) {
	// This promise is ALWAYS resolved to avoid unhandled promise rejection
	let trackPromise = new Promise((resolve, reject) => {
		// Debugging
		log('Track Event:', { category: category, action: action, label: label });

		if ( typeof window.gtag === 'function' ) { // gtag.js
			window.gtag('event', action, {
				'event_category': category,
				'event_action': action, // Event name is default, this is redundant
				'event_label': label,
				'event_callback': () => resolve('gtag event sent!')
			});
		} else if ( typeof window.ga === 'function' ) { // analytics.js
			// Resolve on hitCallback
			window.ga('send', 'event', category, action, label, {
				hitCallback: () => resolve('ga event sent!')
			});
		} else if ( typeof window.__gaTracker === 'function' ) { // analytics.js - monster insights code
			// Resolve on hitCallback
			window.__gaTracker('send', 'event', category, action, label, {
				hitCallback: () => resolve('ga event sent!')
			});
		} else {
			// No handler found!
			return resolve('No analytics tracker exists!');
		}

		// Reject if it takes more than 1s
		setTimeout(() => resolve('Analytics event timed out after 1s'), 1000);
	});

	return trackPromise;
}

/**
 * Callback handler for mousedown and click events which forwards to a URL (if needed)
 *
 * Expects e.data property containing {
 *   category*
 *   action (optional) - defaults to text content
 *   label (optional) - defaults to current window location, pass true for element href
 *   href (optional): where to forward - defautls to element href
 * }
 *
 * @param Event e
 */
export const trackAllClicks = function ( e ) {
	let defaultHandler = () => {
		// Track event
		trackEvent(e.data.category, e.data.action, e.data.label).then((val) => {
			// Debugging
			log('Event message:', val);
		});
	};

	// Set defaults
	if ( ! e.data.action ) {
		e.data.action = e.currentTarget.textContent.trim();
	}
	if ( ! e.data.label ) {
		e.data.label = window.location.href;
	} else if ( e.data.label === true ) { // Special value of true means we want to use the current href
		e.data.label = e.currentTarget.href;
	}
	if ( ! e.data.href ) {
		e.data.href = e.currentTarget.href;
	}

	switch ( e.type ) {
		case 'click':
			if ( e.defaultPrevented ) {
				log('Default prevented on click');
				defaultHandler();
			} else if ( ! e.data.href || e.data.href === '#' ) {
				log('No href on click');
				defaultHandler();
			} else if ( e.currentTarget.protocol && 'javascript:' === e.currentTarget.protocol ) {
				log('JavaScript link on click');
				defaultHandler();
			} else if ( e.currentTarget.target && ! e.currentTarget.target.match( /^_(self|parent|top)$/i ) ) {
				log('Target ' + e.currentTarget.target + ' on click');
				defaultHandler();
			} else if ( e.ctrlKey || e.shiftKey || e.which == 2 ) { // e.which == 2 for jquery-triggered middle clicks
				log('Ctrl/shift/middle click');
				defaultHandler();
			} else {
				log('Delaying click', e.data.href);
				// Special handling
				e.preventDefault();
				trackEvent(e.data.category, e.data.action, e.data.label).then((val) => {
					// Debugging
					log('Event message:', val);

					// Change the window location
					window.location.href = e.data.href;
				});
			}
		break;
		case 'mousedown':
			if ( e.button === 1 ) { // Only track middle clicks
				log('Middle click');
				defaultHandler();
			}
		break;
		default:
			log('Unknown click event', e.type);
			return;
		break;
	}
}
